export default __webpack_public_path__ + "static/media/icon-reset-password-success.02679fb4.svg";